import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import _isNil from "lodash/isNil";
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
} from "@/utils/localStorage";

const state = {
  danhSachQuyenNguoiDung: [],
  danhSachPhanQuyenNguoiDung: _isNil(
    getValueFromStorageByKey(LOCAL_STORAGE_KEY.PERMISSION_DECENTRALIZATION)
  )
    ? ""
    : getValueFromStorageByKey(LOCAL_STORAGE_KEY.PERMISSION_DECENTRALIZATION),
  danhSachChiTietNguoiDung: _isNil(
    getValueFromStorageByKey(LOCAL_STORAGE_KEY.USER_ID)
  )
    ? ""
    : getValueFromStorageByKey(LOCAL_STORAGE_KEY.USER_ID),
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
